import type { CoreApiClient } from "../client";
import { createGroupMutations } from "../mutations/group.mutations";
import { createGroupQueries } from "../queries/group.queries";

export const createGroupRepository = (api: CoreApiClient) => ({
  ...createGroupQueries(api),
  ...createGroupMutations(api),
});
